export default "<ng-template [ngIf]=\"loginDisplay\" [ngIfElse]=\"loading\">\r\n  <router-outlet></router-outlet>\r\n</ng-template>\r\n\r\n";